export default function ExchangeShopRouter(Layout, device) {
  console.log('ExchangeShopRouter---', device);
  return [
    {
      path: '/exchangeShop', // 兑换商城相关
      name: 'ESShop',
      redirect: '/exchangeShop/home',
      component: Layout,
      meta: {
        title: '兑换商城',
        icon: 'icon-exchangeShop',
        activePath: 'exchangeShop',
        showSideBar: true,
      },
      children: [
        {
          path: '/exchangeShop',
          name: 'ESEntry',
          redirect: '/exchangeShop/home',
          component: () => import(`../views/exchangeShop/${device}/index.vue`),
          meta: {
            title: '兑换商城',
            activePath: 'exchangeShop',
            showSideBar: true,
          },
          children: [
            {
              path: 'home',
              name: 'ESHome',
              meta: {
                title: '兑换商城',
                activePath: 'exchangeShop',
                showSideBar: false,
              },
              hidden: true,
              component: () =>
                import(`../views/exchangeShop/${device}/home.vue`),
            },
            {
              path: 'productionDetail/:id',
              name: 'ESProductionDetail',
              meta: {
                title: '商品详情',
                activePath: 'exchangeShop',
                device,
              },
              hidden: true,
              component: () =>
                import(`../views/exchangeShop/${device}/productionDetail.vue`),
            },
            {
              path: 'orderList',
              name: 'ESOrderList',
              meta: {
                title: '订单查询',
                activePath: 'exchangeShop',
              },
              hidden: true,
              component: () =>
                import(`../views/exchangeShop/${device}/orderList.vue`),
            },
          ],
        },
      ],
    },
  ];
}
